module.exports = __webpack_public_path__ + "img/clint10.64f609c0.png";